if (!customElements.get('m-notify-me')) {
  customElements.define(
    'm-notify-me',
    class MNotifyMe extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          content: '.m-form-notify-me',
          form: '#contact-form-notify-me',
          productName: '[data-notify-me-product-name]',
          productField: '[data-notify-me-field="product"]',
          productUrlField: '[data-notify-me-field="product-url"]',
          variantIdField: '[data-notify-me-field="variant-id"]',
          email: '[data-notify-me-email]',
          error: '[data-notify-me-error]',
          submitButton: '.m-notify-me-submit',
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        if (!this.domNodes.content?.innerHTML) return;

        this.content = this.domNodes.content.innerHTML;
        this.colorScheme = this.domNodes.content.dataset.colorScheme;
        this.modal = new MinimogTheme.Modal();
        this.init();
      }

      init() {
        addEventDelegate({
          selector: '[data-notify-me]',
          handler: (e, button) => {
            e.preventDefault();
            this.openModal(button);
          },
        });
      }

      openModal(button) {
        const html = document.createElement('DIV');
        html.innerHTML = this.content;

        const productTitle = button.dataset.productTitle || '';
        const productUrl = button.dataset.productUrl || '';
        const variantId = button.dataset.variantId || '';

        const productNameEl = html.querySelector(this.selectors.productName);
        const productField = html.querySelector(this.selectors.productField);
        const productUrlField = html.querySelector(this.selectors.productUrlField);
        const variantIdField = html.querySelector(this.selectors.variantIdField);

        if (productNameEl) productNameEl.textContent = productTitle;
        if (productField) productField.value = productTitle;
        if (productUrlField) productUrlField.value = productUrl;
        if (variantIdField) variantIdField.value = variantId;

        this.modal.appendChild(html);
        this.modal.setWidth('520px');
        this.modal.setSizes(`m-form-notify-me m-gradient ${this.colorScheme}`);

        const form = html.querySelector(this.selectors.form);
        if (form) {
          form.addEventListener('submit', this.onSubmit.bind(this, form));
        }

        this.modal.open();
      }

      toggleSubmitLoading(form, loading) {
        const submitButton = form.querySelector(this.selectors.submitButton);
        if (!submitButton) return;
        submitButton.classList.toggle('m-spinner-loading', loading);
        submitButton.disabled = loading;
      }

      showError(form, message) {
        const errorEl = form.querySelector(this.selectors.error);
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.classList.remove('m:hidden');
      }

      async onSubmit(form, event) {
        event.preventDefault();

        const errorEl = form.querySelector(this.selectors.error);
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add('m:hidden');
        }

        this.toggleSubmitLoading(form, true);

        try {
          const response = await fetch('/contact', {
            method: 'POST',
            body: new FormData(form),
            headers: {
              Accept: 'text/html',
            },
          });

          if (!response.ok) {
            throw new Error('Request failed');
          }

          this.modal.close();
          MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'success',
            message: window.MinimogStrings.notifyMeSuccess,
            delay: 4000,
            sticky: true,
          });
        } catch (error) {
          this.showError(form, window.MinimogStrings.notifyMeError);
        } finally {
          this.toggleSubmitLoading(form, false);
        }
      }
    }
  );
}
